module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9594.d0c3f3b3.jpg";